import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faWhatsapp,
  faGoogle,
} from '@fortawesome/free-brands-svg-icons';
import '../css/Footer.css'; // Optional if you want to add additional custom styles
import { Link } from 'react-router-dom';
function Footer() {
  return (
    <footer className="text-white pt-5 pb-3 position-relative">
      <div className="container">
        <div className="row text-start">
          {/* Who We Are */}
          <div className="col-md-3 col-sm-6 mb-4">
            <h4 >Who We Are</h4>
            <p style={{ fontSize: '16px' }}>
  TerraGold is a premium nutraceutical manufacturer committed to delivering high-quality organic and plant-based wellness products. By combining nature's finest ingredients with modern manufacturing standards, we create trusted nutritional solutions that support healthier lifestyles and everyday well-being.</p>
          </div>

          <div className="col-md-3 col-sm-6 mb-4">
            <h4 >Links</h4>
            <ul className="list-unstyled footer-links mt-3">

               <Link to="/" style={{ textDecoration: 'none' }}> <li><span>&gt;</span> Home</li></Link>
              <Link to="/aboutus" style={{ textDecoration: 'none' }}> <li><span>&gt;</span> About</li></Link>
              <Link to="/imageslider" style={{ textDecoration: 'none' }}> <li><span>&gt;</span> Services</li></Link>
                   <Link to="/demo" style={{ textDecoration: 'none' }}> <li><span>&gt;</span> Product</li></Link>
              <Link to="/contact" style={{ textDecoration: 'none' }}> <li><span>&gt;</span> Contact Us</li></Link> 
            </ul>
          </div>


          {/* Contact Info */}
          <div className="col-md-3 col-sm-6 mb-4">
            <h4 >Contact</h4>
            <ul className="list-unstyled" style={{ fontSize: '16px' }}>
              <li><strong>Phone:</strong> +91- 8180090266  </li>
              <li><strong>Email:</strong> dashrath7865p@gmail.com</li>
              <li><strong>Address:</strong>       A-54 MIDC karad Tal-karad Dist-satara,4115110</li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="col-md-3 col-sm-6 mb-4">
            <h4 >Social Media</h4>
            <ul className="list-unstyled d-flex gap-3 mt-3">
              <li>
                <a href="#" className="btn btn-outline-light rounded-circle p-3">
                  <FontAwesomeIcon style={{fontSize:'18px'}} icon={faFacebookF} />
                </a>
              </li>
              <li>
                <a href="#" className="btn btn-outline-light rounded-circle p-3">
                  <FontAwesomeIcon style={{fontSize:'18px'}} icon={faTwitter} />
                </a>
              </li>
              <li>
                <a href="#" className="btn btn-outline-light rounded-circle p-3">
                  <FontAwesomeIcon style={{fontSize:'18px'}} icon={faInstagram} />
                </a>
              </li>
              <li>
                <a href="#" className="btn btn-outline-light rounded-circle p-3">
                  <FontAwesomeIcon style={{fontSize:'18px'}} icon={faWhatsapp} />
                </a>
              </li>
             
            </ul>
          </div>
        </div>

        {/* Footer bottom */}
      
      </div>
      <div className="text-center pt-3 mt-3" style={{ fontSize: '14px', backgroundColor:'rgba(255, 255, 255, 0.1)',padding:'10px',margin:'10px' }}>
          © 2025 Lissom Technologies Pvt. Ltd. | All Rights Reserved
        </div>
    </footer>
  );
}

export default Footer;
